import { TaskEither, Either, right, left, taskEither, fetchData } from '@shared-commons/utils';

type DeleteProfileType = { success?: boolean; message?: string; error?: string; status?: number };

export const deleteProfile = (
  email: string | undefined,
  userUid: string,
  accessToken: string | null,
): TaskEither<Error, DeleteProfileType> => {
  const validateDelete = (response: DeleteProfileType): Either<Error, DeleteProfileType> => {
    if (response.success) {
      return right(response);
    }
    return left(
      new Error(
        `Validation error: ${response.message || 'An error has occurred during Delete Profile'}`,
      ),
    );
  };
  const adapter = (response: DeleteProfileType): TaskEither<Error, DeleteProfileType> =>
    taskEither(async () => right(response));

  return fetchData<DeleteProfileType>(
    `${process.env.NEXT_PUBLIC_HOST}/api/profile/me/delete?email=${email}&userUid=${userUid}`,
    adapter,
    validateDelete,
    'DELETE',
    {
      Authorization: `Bearer ${accessToken}`,
    },
  );
};
